import { readLocalStorage, writeLocalStorage } from '../../local-storage'

function toStorageKey(meetingId: number): string {
  return `editor-track-changes:${meetingId}`
}

export function readTrackChangesEnabled(meetingId: number): boolean {
  return readLocalStorage(toStorageKey(meetingId)) === 'true'
}

export function writeTrackChangesEnabled(meetingId: number, enabled: boolean) {
  writeLocalStorage(toStorageKey(meetingId), enabled ? 'true' : 'false')
}
